import ConsentModel from './consent'
import {setCookie} from '../util/storage'

export default class ConsentModModel extends ConsentModel {
  public async save (origin: string): Promise<void> {
    const response = await this.send(origin)
    const {euconsent, uuid} = await response.json()

    this.updateStorage(euconsent, uuid)

    setCookie(ConsentModel.cookieName, euconsent, this.getCookieExpireDays(this.consented))
    setCookie('uuid', uuid, 100 * 365)

    this.load()
    this.emit('update')
  }
}
